export default __webpack_public_path__ + "static/media/showcase-whoami.d31f0aa4.jpg";